import { centralEnabled } from '@/config/api'
import type { Session } from '@/models/auth'

const sessionKey = 'smoothbadger.session'

function parseSession(raw: string): Session | null {
  try {
    return JSON.parse(raw) as Session
  } catch {
    return null
  }
}

export function readSession(): Session | null {
  if (centralEnabled) { const raw = sessionStorage.getItem(sessionKey); return raw ? parseSession(raw) : null }
  const saved = localStorage.getItem(sessionKey)
  if (saved) {
    const session = parseSession(saved)
    if (session) return session
    localStorage.removeItem(sessionKey)
    return null
  }
  const legacy = sessionStorage.getItem(sessionKey)
  if (!legacy) return null
  const session = parseSession(legacy)
  sessionStorage.removeItem(sessionKey)
  if (!session) return null
  localStorage.setItem(sessionKey, legacy)
  return session
}

export function writeSession(session: Session) {
  if (centralEnabled) {
    localStorage.removeItem(sessionKey)
    // Share the non-secret selection hint, while each tab retains its own business context.
    if (session.businessUserId) localStorage.setItem('crm-last-membership', session.businessUserId)
    else localStorage.removeItem('crm-last-membership')
    sessionStorage.setItem(sessionKey, JSON.stringify(session))
    return
  }
  localStorage.setItem(sessionKey, JSON.stringify(session))
  sessionStorage.removeItem(sessionKey)
}

export function clearSession() {
  localStorage.removeItem('crm-last-membership')
  localStorage.removeItem(sessionKey)
  sessionStorage.removeItem(sessionKey)
}

export function watchSession(onChange: (session: Session | null) => void): () => void {
  function handle(event: StorageEvent) {
    if (event.key !== sessionKey) return
    onChange(event.newValue ? parseSession(event.newValue) : null)
  }
  window.addEventListener('storage', handle)
  return () => window.removeEventListener('storage', handle)
}

const noticeKey = 'smoothbadger.notice'
let pendingNotice: string | null = null

export function stashNotice(message: string) {
  pendingNotice = message
  sessionStorage.setItem(noticeKey, message)
}

export function consumeNotice(): string | null {
  pendingNotice ??= sessionStorage.getItem(noticeKey)
  return pendingNotice
}

export function clearNotice() {
  pendingNotice = null
  sessionStorage.removeItem(noticeKey)
}
